import styled from 'styled-components'

export const StyledRightActionButton = styled.button`
  background-color: var(--tds-red-400);
  align-self: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  place-content: center;

  color: var(--tds-white);

  &:hover {
    background-color: var(--tds-red-500);
  }
`

export const RightActionButton = ({
  icon,
  id,
  onClick,
  ...props
}: {
  id: string
  icon: JSX.Element
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}): JSX.Element => {
  return (
    <StyledRightActionButton onClick={onClick} type='button' id={id} {...props}>
      {icon}
    </StyledRightActionButton>
  )
}
